<template>
  <StepOne
    v-if="step === 0"
    :campaign-name="campaignName"
    :campaign-objective="campaignObjective"
    :status="status"
    @update:campaignName="$emit('update:campaignName', $event)"
    @update:campaignObjective="$emit('update:campaignObjective', $event)"
    @update:status="$emit('update:status', $event)"
    @next="$emit('update:step', step + 1)"
  />
  <StepTwo
    v-else-if="step === 1"
    @next="$emit('update:step', step + 1)"
    @prev="$emit('update:step', step - 1)"
  />
  <StepThree
    v-else-if="step === 2 && !reviewMode"
    @prev="$emit('update:step', step - 1)"
    @submit="$emit('update:reviewMode', true)"
  />
  <ReviewPage
    v-else-if="step === 2 && reviewMode"
    @exit-review="$emit('update:reviewMode', false)"
    @go-to-step="$emit('update:step', $event)"
  />
</template>
<script>
import StepOne from "@/components/SuperApp/Awareness/StepOne.vue";
import StepTwo from "@/components/SuperApp/Awareness/StepTwo";
import StepThree from "@/components/SuperApp/Awareness/StepThree.vue";
import ReviewPage from "@/components/SuperApp/Awareness/ReviewPage.vue";
export default {
  name: "AwarenessFlow",
  props: {
    campaignName: String,
    campaignObjective: String,
    status: Boolean,
    step: Number,
    reviewMode: Boolean,
  },
  emits: [
    "update:campaignName",
    "update:campaignObjective",
    "update:status",
    "update:step",
    "update:reviewMode",
  ],
  components: {
    StepOne,
    StepTwo,
    StepThree,
    ReviewPage,
  },
  watch: {
    step(val) {
      console.log("STEP UPDATED IN INDEX:", val);
    },
  },
};
</script>
